import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as endpoints from './../../../../Service/endpoints';
import Modal from '../../../UI/Modal';
import Icon from '../../../UI/Icon';
import "./../../../../styles/modal-styles.css";

// Service areas currently supported by the storefront (ids match the inventory API).
const CITIES = endpoints.CITY_OPTIONS;

class ServiceAreaSelect extends Component {

    selectCity = (cityName, cityId) => {

        localStorage.setItem("city", cityName);
        localStorage.setItem("cityId", cityId);
        this.props.selectCityClose();

        // Swap the city segment of a city URL; other pages go to the city home.
        var segments = window.location.pathname.split("/").filter(Boolean);
        var onCityPage = segments.length > 0 && endpoints.getCityOption(segments[0]);
        var rest = onCityPage ? segments.slice(1).join("/") : "";
        window.location.href = endpoints.getRoute(rest, cityName);

    }

    closeModal = () => {
        this.props.selectCityClose();
    }

    componentDidMount() {
        if (typeof navigator !== "undefined" && /ReactSnap/i.test(navigator.userAgent || "")) {
            return;
        }

        const currentCity = endpoints.getCurrentCity();

        if (typeof localStorage.city === "undefined") {
            this.props.selectCityOpen();
        } else {
            if (window.location.pathname === "/") {
                window.location.href = `/${currentCity}`;
            }
        }
    }


    render() {
        const current = typeof localStorage.city !== "undefined" ? endpoints.getCurrentCity() : null;
        return (
            <Modal open={this.props.selectCity.show} onClose={this.closeModal} title="Choose your city" variant="sheet">
                <p className="v-city__intro">Availability and pricing are specific to each city.</p>
                <div className="v-city">
                    {CITIES.map((city) => (
                        <button
                            key={city.name}
                            type="button"
                            className={`v-city__option ${current === city.name ? 'is-current' : ''}`}
                            aria-current={current === city.name ? 'true' : undefined}
                            onClick={() => this.selectCity(city.name, city.id)}
                        >
                            <span className="v-city__icon"><Icon name="pin" size={20} /></span>
                            <span className="v-city__name">{city.label}</span>
                            {current === city.name
                                ? <span className="v-city__tag">Current</span>
                                : <Icon name="chevronRight" size={18} className="v-city__chev" />}
                        </button>
                    ))}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (currentState) => {
    return {
        selectCity: currentState.selectCity,
    };
};

const mapActionsToProps = (dispatch) => {
    return {
        selectCityOpen: () => {
            dispatch({ type: 'user.city.show' });
        },
        selectCityClose: () => {
            dispatch({ type: 'user.city.hide' });
        }
    };
}

export default connect(mapStateToProps, mapActionsToProps)(ServiceAreaSelect);
